class HeaderDrawer extends HTMLElement {
  constructor() {
    super();
    this.details = this.querySelector('details');
    this.summary = this.querySelector('summary');
    this.drawer = this.querySelector('.menu-drawer');
    this.backdrop = this.querySelector('.menu-drawer__backdrop');

    this.bindEvents();
  }

  bindEvents() {
    if (!this.summary || !this.details) return;

    // OPEN
    this.summary.addEventListener('click', (e) => {
      e.preventDefault();
      this.openDrawer();
    });

    // CLOSE (backdrop)
    if (this.backdrop) {
      this.backdrop.addEventListener('click', () => {
        this.closeDrawer();
      });
    }

    // CLOSE (ESC key)
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') {
        this.closeDrawer();
      }
    });
  }

  openDrawer() {
    this.details.setAttribute('open', '');
    document.documentElement.classList.add('menu-open');
    document.body.classList.add('menu-open');
  }

  closeDrawer() {
    this.details.removeAttribute('open');
    document.documentElement.classList.remove('menu-open');
    document.body.classList.remove('menu-open');
  }
}

customElements.define('header-drawer', HeaderDrawer);
